<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" class="py-4"> </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" class="px-4 py-10 white">
        <div class="d-flex mx-3">
          <v-img :src="logo.photo" max-width="32" />
          <div class="text-h6 font-weight-black mx-2">{{ logo.name }}</div>
        </div>
        <div align="center" class="py-8">
          <v-img :src="errorData.img" max-width="362" />
        </div>
        <div class="text-h5 font-weight-black">{{ errorData.code }}</div>
        <div class="text-h5 font-weight-black">{{ errorData.title }}</div>
        <div class="py-4"></div>
        <div class="text-body-1 font-weight-bold">{{ errorData.sub }}</div>
        <div class="py-9">
          <v-btn color="primary" large @click="GoHome()">{{
            errorData.btntext
          }}</v-btn>
        </div>
        <div class="text-caption text--disabled">{{ copytight }}</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Error",
  data: () => ({
    nowComponents: "",
    logo: {
      photo: require("@/assets/logo.svg"),
      name: "小芋頭",
    },
    errorData: {
      img: require("@/assets/image/components/Group.svg"),
      code: "404",
      title: "很抱歉，我們找不到該頁面",
      sub: "頁面可能已經遭到移除或當前網路狀態不佳",
      btntext: "前往小芋頭社群首頁",
    },
    copytight: "COPYRIGHT © 小芋頭工作室 All rights reserved.",
  }),
  methods: {
    GoHome() {
      let openWindow = window.open();
      openWindow.location = this.$store.state.fromSite.url;
      this.$router.push({ name: "SignIn" });
    },
  },
};
</script>
